import { CalendarMode, Row } from "PFApp/booking/types";
import React, { useMemo } from "react";

import { RowType } from "../../../../../../types/row";
import { useBookingsOverviewContext } from "../../../../context/bookings_overview_context";
import { useCalendarContext } from "../../../../context/calendar_context";
import { Overbookings } from "../../../bars/overbookings/overbookings";
import { useHeatMapItems } from "../../heat_map_row/use_heat_map_items";
import { groupItemsByAvailability } from "../availability_row.utils";
import { AvailabilityItem } from "./availability_item";

type AvailabilityHeatMapRowProps = {
  row: Row;
  startDate: string;
};

export const AvailabilityHeatMapRow = ({ row, startDate }: AvailabilityHeatMapRowProps): JSX.Element => {
  const { calendarMode } = useBookingsOverviewContext();
  const { dayWidth } = useCalendarContext();
  const items = useHeatMapItems({
    row,
    startDate,
    dayWidth
  });

  const itemsGrouped = useMemo(() => groupItemsByAvailability(items), [items]);
  const shouldDisplayOverbookings = calendarMode === CalendarMode.Workforce && row.type === RowType.Profile;

  return (
    <>
      {shouldDisplayOverbookings && <Overbookings row={row} startDate={startDate} />}
      {itemsGrouped.map((itemsGroup) => (
        <AvailabilityItem key={`${row.key}_${itemsGroup[0].date}_${itemsGroup.length}`} items={itemsGroup} />
      ))}
    </>
  );
};
